import {
    GET_MARKETING_SLOT_BANNER,
    GET_IRIS_MARKETING_SLOT_BANNER,
} from '../actionTypes/CartActionTypes';

export const getMarketingSlotBanner = () => ({
    type: GET_MARKETING_SLOT_BANNER,
});

export const getIrisMarketingSlotBanner = (channel) => ({
    type: GET_IRIS_MARKETING_SLOT_BANNER,
    payload: channel,
});
